
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subject",
      function () {
        return require("private-next-pages/subject/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subject"])
      });
    }
  